import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Footer from './components/Footer';
import Contact from './components/Contact';
import GstRobo from './components/GstRobo';
import GstSoftware from './components/GstSoftware';
import Whoweare from './components/Whoweare';
import EWayBillSoftware from './components/EWayBillSoftware';
import ScrollToTop from './components/ScrollToTop';
import IntelligenceInsight from './components/IntelligenceInsight';
import ValueAdded from './components/ValueAdded';
import GstEwayBillApi from './components/GstEwayBillApi';
import EInvoicingSoftware from './components/EInvoicingSoftware';
import Acp from './components/Acp';
import AcpSalesPartner from './components/AcpSalesPartner';
import AcpExecutionPartner from './components/AcpExecutionPartner';
import AcpSystemIntegraionPartner from './components/AcpSystemIntegraionPartner';
import AcpDistributorPartner from './components/AcpDistributorPartner';
import AcpServicePartner from './components/AcpServicePartner';
import AcpMarketingPartner from './components/AcpMarketingPartner';
import AcpLiaisonPartner from './components/AcpLiaisonPartner';
import DetelEbike from './components/DetelEbike';
import LedLights from './components/LedLights';
import { Verification } from './components/Verification';


export default function App() {
  return (
    <div>
      <HashRouter>
        <ScrollToTop />
          < Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/whoweare" element={< Whoweare />} />
            <Route path="/gst-robo" element={<GstRobo />} />
            <Route path="/gst-software" element={<GstSoftware />} />
            <Route path="/e-way-bill-software" element={<EWayBillSoftware />} />
            <Route path="/intelligence-insight" element={<IntelligenceInsight />} />
            <Route path="/value-added-tools" element={<ValueAdded />} />
            <Route path="/gst-e-way-bill-api" element={<GstEwayBillApi />} />
            <Route path="/e-invoicing-software" element={<EInvoicingSoftware />} />
            <Route path="/about-acp" element={<Acp />} />
            <Route path="/acp-sales-partner" element={<AcpSalesPartner />} />
            <Route path="/acp-execution-partner" element={<AcpExecutionPartner />} />
            <Route path="/acp-system-integration-partner" element={<AcpSystemIntegraionPartner />} />
            <Route path="/acp-distributor-partner" element={<AcpDistributorPartner />} />
            <Route path="/acp-service-partner" element={<AcpServicePartner />} /> 
            <Route path="/acp-marketing-partner" element={<AcpMarketingPartner />} /> 
            <Route path="/acp-liaison-partner" element={<AcpLiaisonPartner />} /> 
            <Route path="/detel-e-bike" element={<DetelEbike />} />
            <Route path="/led-lights" element={<LedLights />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/verification" element={<Verification/>}/>
          </Routes>
          < Footer />
      </HashRouter>
    </div>
  )
}